const TheContainer = () => import('@/containers/TheContainer')

export default [
    {
        path: '/contract-manager/:contractManagerId/collaborators',
        component: TheContainer,
        children: [
            {
                path: '',
                name: 'contractManager.collaborators',
                component: () => import('./index.vue'),
                meta: {
                    scopeType: 'contract-manager',
                    permission: 'contract_manager.collaborator.list'
                }
            }
        ]
    },
    {
        path: '/admin/collaborators',
        component: TheContainer,
        children: [
            {
                path: '',
                name: 'admin.collaborators',
                component: () => import('./index.vue'),
                meta: {
                    scopeType: 'global',
                    permission: 'admin.collaborator.list'
                }
            }
        ]
    }
];